<!-- 加油注册表-->
<template>
    <div>
        <div id="formHtml" style="padding:30px 30px;">
            <div style="background:#1c1c1c;">
                <table cellspacing="1" cellpadding="0" width="100%">
                    <tbody>
                    <tr>
                        <td colspan="4"  style="height:100px;"><h2>企业内部撬装柴油加油装置信息登记表</h2></td>
                    </tr>
                    <tr>
                        <td>
                            <p><span>企业名称</span><span><o:p></o:p></span></p>
                        </td>
                        <td><p><span><input type="text" v-model="form.entName" :class="edit(form.entName)"/></span></p></td>
                        <td>
                            <p><span>所属行业</span><span><o:p></o:p></span></p>
                        </td>
                        <td><p><span><input type="text" v-model="form.industry" :class="edit(form.industry)"/></span></p></td>
                    </tr>
                    <tr>
                        <td>
                            <p><span>撬装设立地址</span><span><o:p></o:p></span></p>
                        </td>
                        <td colspan="3">
                            <p><input type="text" v-model="form.workAddress" :class="edit(form.workAddress)"/></p>
                        </td>
                    </tr>
                    <tr>
                        <td><p ><span>需要加注柴油的车</span><span>&nbsp;</span><span>辆及设备（注）</span><span><o:p></o:p></span></p>
                        </td>
                        <td>
                            <p><span>车辆</span><span>—</span><span>辆，非道路移动式机械</span><span>—</span><span>台</span><span><o:p></o:p></span>
                            </p>
                        </td>
                        <td>
                            <p><span>毎月预计用量</span><span><o:p></o:p></span></p>
                        </td>
                        <td>
                            <p><span>（吨）</span><span><o:p></o:p></span></p>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p><span>预计建设</span><span>时间</span><span><o:p></o:p></span></p>
                        </td>
                        <td><p><span>&nbsp;</span></p></td>
                        <td>
                            <p><span>撬装罐容</span><span><o:p></o:p></span></p>
                        </td>
                        <td><p><span>&nbsp;</span></p></td>
                    </tr>
                    <tr>
                        <td>
                            <p><span>企业负责人</span><span><o:p></o:p></span></p>
                        </td>
                        <td><p><span v-text="form.contactName">&nbsp;</span></p></td>
                        <td>
                            <p><span>联系方式</span><span><o:p></o:p></span></p>
                        </td>
                        <td><p><span v-text="form.contactPhone">&nbsp;</span></p></td>
                    </tr>
                    <tr>
                        <td>
                            <p><span>企业承诺</span><span><o:p></o:p></span></p>
                        </td>
                        <td  colspan="3" style="text-align: left;">
                            <p style="text-indent:30px;"><span>我承诺遵守相关法律、法规，设立的撬装柴油加油装置接入区属信 息平台，且仅对自用车辆加注来源合法、质量合格的柴油。</span></p>
                            <br/>
                            <br/>
                            <br/>
                            <br/>
                            <div style="display:flex;">
                                <div style="flex:1">
                                    企业负责人：<br/><br/><br/>
                                    日期：<br/><br/>
                                </div>
                                <div style="flex:1">
                                    （签字）<br/><br/><br/>
                                    （单位盖章）<br/><br/>
                                </div>
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <td><p ><span>所在地街镇或园区</span><span>&nbsp;</span><span>意见</span><span><o:p></o:p></span></p>
                        </td>
                        <td style="text-align: left;">
                            <br/>
                            <br/>
                            <br/>
                            <br/>
                            <br/>
                            <div style="display:flex;">
                                <div style="flex:1">
                                    经办人：<br/><br/><br/>
                                    日期：<br/><br/>
                                </div>
                                <div style="flex:1">
                                    （签字）<br/><br/><br/>
                                    （单位盖章）<br/><br/>
                                </div>
                            </div>
                        </td>
                        <td><p  ><span>行业主管部门</span><span>&nbsp;</span><span>意见</span><span><o:p></o:p></span></p></td>
                        <td style="text-align: left;">
                            <br/>
                            <br/>
                            <br/>
                            <br/>
                            <br/>
                            <div style="display:flex;">
                                <div style="flex:1">
                                    经办人：<br/><br/><br/>
                                    日期：<br/><br/>
                                </div>
                                <div style="flex:1">
                                    （签字）<br/><br/><br/>
                                    （单位盖章）<br/><br/>
                                </div>
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <td><p ><span>成品油主管部门</span><span>&nbsp;</span><span>意见</span><span><o:p></o:p></span></p></td>
                        <td  colspan="3">
                            <br/>
                            <br/>
                            <br/>
                            <br/>
                            <br/>
                            <div style="display:flex;">
                                <div style="flex:1">
                                    经办人：<br/><br/><br/>
                                    日期：<br/><br/>
                                </div>
                                <div style="flex:1">
                                    （签字）<br/><br/><br/>
                                    （单位盖章）<br/><br/>
                                </div>
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <td style="height:100px;">
                            <p><span>登记号</span><span>&nbsp;</span><span>.</span><span><o:p></o:p></span></p>
                        </td>
                        <td colspan="3" align="left">
                             <p style="width:220px;border-bottom:solid 1px #000;display:inline-block;">&nbsp;</p><span>区</span><p style="width:80px;border-bottom:solid 1px #000;display:inline-block;">&nbsp;</p><span>号</span>

                        </td>
                    </tr>
                    </tbody>
                </table>

            </div>
        </div>
        <div class="dialog-footer" style="margin-top:10px;text-align: center;">
            <span style="color:red;">（提示：请下载后自行打印并线下盖章再上传）</span>
            <el-button @click="closeDialog()" size="small">取 消</el-button>
            <el-button size="small" type="primary" @click="create('form')">点击下载</el-button>

        </div>
        <a id="download" v-show="false"/>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex';
    import {enterpriseDetail} from "../../../api/admin/sysEnterprise/index";
    import {addObj, getObj, putObj} from "../../../api/admin/sysOilRegister/index";
    import * as html2canvas from "html2canvas";

    export default {
        name: 'oilRegisterForm',
        props: ["formId", "prop"],
        data() {
            return {
                form: {
                    entName:null,
                    contactName:null,
                    contactPhone:null,
                    industry:null,
                    workAddress:null,
                },
                cDate: {
                    issueYear: null,
                    issueMonth: null,
                    issueDay: null,

                    noticeYear: null,
                    noticeMonth: null,
                    noticeDay: null,

                    noticeYear2: null,
                    noticeMonth2: null,
                    noticeDay2: null,
                },
            }
        },
        created() {
            this.init();
        },
        computed: {
            ...mapGetters([
                'elements'
            ])
        },
        watch: {
        },
        methods: {
            init: function () {
                this.form.workAddress= this.prop.workAddress;
                enterpriseDetail({}).then(response => {
                    console.log(response)
                    this.form.entName = response.entName;
                    this.form.registeredAddress = response.regAddressName + response.regAddressDetail;
                    this.form.businessAddress = response.workAddressName + response.workAddressDetail;
                    this.form.contactName = response.contactName;
                    this.form.contactPhone = response.contactPhone;
                });
            },
            html(callback) {
                html2canvas(document.querySelector("#formHtml"), {scale: 2}).then(canvas => {
                    callback && callback(canvas);
                })
            },
            download(fileName){
                this.html((canvas)=>{
                    fileName += ".png";
                    if (window.navigator.msSaveBlob) {
                        var blob = canvas.msToBlob()
                        window.navigator.msSaveBlob(blob, fileName)
                    } else {
                        var url = canvas.toDataURL()     //把canvas转成base64
                        // 写一个隐藏的按标签，借助按标签的download属性下载图片
                        document.querySelector('#download').href = url;
                        document.querySelector('#download').download = fileName;
                        document.querySelector('#download').click()
                    }
                });
            },
            create() {
                 this.download('企业内部撬装柴油加油装置信息登记表');
            },
            update() {
                putObj(this.form.formId, this.form).then(() => {
                    this.$notify({
                        title: '成功',
                        message: '更新成功',
                        type: 'success',
                        duration: 2000
                    });
                    this.html(canvas => {
                        this.$emit("on-success", {...this.form, content: canvas.toDataURL()});
                    })
                });
            },
            checkRadio: function (prop, index, array) {
                if (!array[index].state) {
                    this.form[prop] = index;
                    array.forEach(item => {
                        item.state = false;
                    })
                } else {
                    prop = null;
                }
            },
            fdate: function (a, b, c) {
                return (a || "") + "-" + (b || "") + "-" + (c || "");
            },
            edit: function (val) {
                if (val && String.valueOf(val).length > 0) {
                    return "edit";
                }
                return "";
            },
            closeDialog() {
                this.$emit('close')
            }
        }
    }
</script>
<style scoped>
    table td {
        background: #FFF;
        padding: 0px 4px;
        height: 40px;
        box-sizing: border-box;
        text-align: center;
    }

    table td .checkbox {
        width: 16px;
        height: 16px;
        border: solid 1px #000;
        background: #FFF;
        position: relative;
        top: 3px;
    }

    table td input {
        background: url(./img/edit.png) 10px no-repeat;
        width: 100%;
        height: 100%;
        border: none;
        text-indent: 0px;
        border: none;
        font-size: 14px;
        outline: none;
        padding-left: 10px;
        box-sizing: border-box;
    }

    table td .shortInput {
        width: 60px;
        height: 100%;
        border: none;
    }

    table td .longInput {
        width: 290px;
        height: 100%;
        border: none;
    }

    .edit {
        background: transparent;
    }
</style>